module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/3K89p9QwIgdZdejBASEkS4-267ce27cccde0c50bb00752880153e3a.jpg";